export default __webpack_public_path__ + "static/media/forward.47782919.svg";